import styled from 'styled-components';

export const CarouselContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  @media (max-width: 1080px) {
    margin-right: 24px;
    margin-left: 24px;
}
`;

export const CarouselCloseContainer = styled.div`
  align-self: flex-end;
  margin: 8px;
  margin-right:24px;
  position: absolute;
  top: 0;
  z-index: 1;
`;

export const BannerWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

            
export const PromotionWrapperSpacer = styled.div<{ expanded: boolean }>`
  background-color: ${({ theme }) => (theme.darkMode ? '#1A1A1A' : '#f2f2f2')};
  overflow: auto;
  display: flex;
  justify-content: center;
  margin-top:10px;
  @media (max-width: 1080px) {
    height: ${({ expanded }) => (expanded ? '122px' : '0px')};
}
@media (max-width: 500px) {
    height: ${({ expanded }) => (expanded ? '175px' : '0px')};
}
@media (max-width: 470px) {
    height: ${({ expanded }) => (expanded ? '195px' : '0px')};
}
`;

export const PromotionWrapper = styled.div<{ expanded: boolean }>`
    display: flex;
    height: ${({ expanded }) => (expanded ? '122px' : '0px')}x;  
    width: 100%;
    flex-direction: column;
    max-width: 1664px;
    @media (max-width: 1080px) {
        height: ${({ expanded }) => (expanded ? '122px' : '60px')};
    }
`;

export const PromotionBanner = styled.div<{ darkMode: boolean }>`
    display: flex;
    height: 122px;  
    width: 100%;    
    background-color: ${({ darkMode }) => (darkMode ? '#1A1A1A' : '#f2f2f2')};
    @media (max-width: 1080px) {
        height: 278px;
    }
`;

export const LeftSpace = styled.div<{ closetColor: string | null }>`
    background-color: ${({ closetColor }) => (closetColor)};
    flex: 1;
    @media (max-width: 1080px) {
        flex: 0;
        width: 0px;
    }
`

export const RightSpace = styled.div`
    flex: 1;
    @media (max-width: 1080px) {
        flex: 0;
        width: 0px;
    }
`

export const BannerBody = styled.div`
    width: 100%;
`

export const GreetingWrapperSpacer = styled.div<{expanded: boolean }>`
  background-color: ${({ theme }) => (theme.darkMode ? '#000' : '#FFF')};
  overflow: auto;
  display: flex;
  justify-content: center;
  height: min-content;
  @media (max-width: 470px) {
    height: ${({ expanded }) => (expanded ? '45px' : '60px')};
}
`;

export const GreetingWrapper = styled.div<{ expanded: boolean }>`
    display: flex;  
    height: 60px;  
    width: 100%; 
    align-items: center;
    max-width: 1664px;
    @media (max-width: 470px) {
        height: ${({ expanded }) => (expanded ? '30px' : '60px')};
        padding-top: ${({ expanded }) => (expanded ? '10px' : '0px')};
    }
`;

export const GreetingBody = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 10px;
    width: 1664px;
    font-weight: 600;
    @media (max-width: 500px) {
        flex-direction: column-reverse;
        align-items: flex-start;
        width: 100%; 
        margin-top: 10px;
        height: 30px;
    }
`;

export const GeetingMessage = styled.div`
    padding-left: 15px;
    @media (max-width: 1080px) {
        padding-left: 22px;
    }
    @media (max-width: 470px) {
        padding-left: 16px;
        height: 30px;
    }
`;

export const BannerOptions = styled.div`
    padding-right: 23px;
    display: flex;
    flex-direction: row;
    cursor: pointer;
    @media (max-width: 1080px) {
        padding-right: 32px;
    };
    @media (max-width: 500px) {
        padding-right: 16px;
        align-self: end;
        height: 36px;
    };
`;


export const BannerCardContainer = styled.div`
  height: 122px;
  display: flex;
  width: 100%;
  background-color: ${({ theme }) => (theme.darkMode ?  '#1A1A1A' : '#f2f2f2')};
  margin-left: -10px;
  @media (max-width: 1080px) {
    width: 100%;
    height: 122px;
    padding-right: 96px;
    padding-left:24px;
    margin-left: 0px;
  }
  @media (max-width: 500px) {
    width: 100%;
    height: 175px;
    padding-right: 96px;
    padding-left:24px;
  }
  @media (max-width: 470px) {
    width: 100%;
    height: 195px;
    padding-right: 88px;
    padding-left:16px;
  }
`;

export const BannerImage = styled.div<{ url: string; id: string, theme:string }>`
  -webkit-box-align: center;
  -webkit-box-pack: center;
  align-items: center;
  background-attachment: fixed;
  background-color: ${({ id, theme }) => (theme.darkMode ?  '#1A1A1A' : '#f2f2f2')};
  background-image: url(${({ url }) => url});
  background-position: left;
  background-repeat: no-repeat;
  background-size: 70%;
  display: flex;
  justify-content: center;
  margin-left:24px;
  height: ${({ url }) => (url ?  '100%' : '0px')};
  min-width: ${({ url }) => (url ?  '200px' : '0px')};
  @media (max-width: 1080px) {
    background-size: 70%;
    background-position: left center;
    width: ${({ url }) => (url ?  '20%' : '0px')};
    margin-left:0px;
  }
  @media (max-width: 500px) {
    width: 0px;
    min-width: 0px;
  }
`;

export const BannerContent = styled.div`
  background-color: ${({ theme }) => (theme.darkMode ?  '#1A1A1A' : '#f2f2f2')};
  color: ${({ theme }) => (theme.darkMode ? '#E6E6E6' : '#1A1A1A')};
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 122px;
  margin-right: 72px;
  text-align: start;
  @media (max-width: 470px) {
    height: 127px;
  }
  @media (max-width: 500px) {
    margin-right: 42px;
  }
`;

export const BannerContentFooter = styled.div`
  bottom: 12px;
  position: absolute;
  right: 72px;
  @media (max-width: 1080px) {
    right: 72px;
  }
  @media (max-width: 700px) {
    right: 0px;
  }
`;

export const BannerIntro = styled.div`
  font-size: 14px;
  font-weight: 500;
  padding: 10px 0px 0 6px;
  padding-left: 0px;
  @media (max-width: 700px) {
    width: 160%;
  }
`;

export const BannerDescription = styled.div`
  font-size: 16px;
  font-weight: 500;
  padding: 0px 6px 6px;
  padding-left: 0px;
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; 
  -webkit-box-orient: vertical;
  white-space: normal;
  width: 100%;
  @media (max-width: 500px) {
    height: 80px;
    -webkit-line-clamp: 4; 
  }
  @media (max-width: 391px) {
    height: 100px;
    -webkit-line-clamp: 5; 
    width: 145% !important;
  }
  @media (max-width: 800px) {
    width: 110%;
  }
  @media (max-width: 700px) {
    width: 120%;
  }
`;


